// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file message_preferences.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file message_preferences.proto.
 */
export const file_message_preferences: GenFile = /*@__PURE__*/
  fileDesc("ChltZXNzYWdlX3ByZWZlcmVuY2VzLnByb3RvEgtncnBjLmFwaS52MSJ9Cg9NZXNzYWdlU2V0dGluZ3MSFgoOZGVmYXVsdF9sb2NhbGUYASABKAkSFwoPZW5hYmxlZF9sb2NhbGVzGAIgAygJEhwKFGNvbW11bmljYXRpb25fc3R5bGVzGAMgAygJEhsKE2NvbW11bmljYXRpb25fZmxhZ3MYBCADKAkikgEKEk1lc3NhZ2VUcmFuc2xhdGlvbhIOCgZsb2NhbGUYASABKAkSEAoIdGV4dF9rZXkYAiABKAkSEgoKdGV4dF92YWx1ZRgDIAEoCRIhChlkZWZhdWx0X2Zvcm1hbF90ZXh0X3ZhbHVlGAQgASgJEiMKG2RlZmF1bHRfaW5mb3JtYWxfdGV4dF92YWx1ZRgFIAEoCUIGWgQuO3BiYgZwcm90bzM");

/**
 * @generated from message grpc.api.v1.MessageSettings
 */
export type MessageSettings = Message<"grpc.api.v1.MessageSettings"> & {
  /**
   * @generated from field: string default_locale = 1;
   */
  defaultLocale: string;

  /**
   * @generated from field: repeated string enabled_locales = 2;
   */
  enabledLocales: string[];

  /**
   * @generated from field: repeated string communication_styles = 3;
   */
  communicationStyles: string[];

  /**
   * @generated from field: repeated string communication_flags = 4;
   */
  communicationFlags: string[];
};

/**
 * Describes the message grpc.api.v1.MessageSettings.
 * Use `create(MessageSettingsSchema)` to create a new message.
 */
export const MessageSettingsSchema: GenMessage<MessageSettings> = /*@__PURE__*/
  messageDesc(file_message_preferences, 0);

/**
 * @generated from message grpc.api.v1.MessageTranslation
 */
export type MessageTranslation = Message<"grpc.api.v1.MessageTranslation"> & {
  /**
   * @generated from field: string locale = 1;
   */
  locale: string;

  /**
   * @generated from field: string text_key = 2;
   */
  textKey: string;

  /**
   * @generated from field: string text_value = 3;
   */
  textValue: string;

  /**
   * @generated from field: string default_formal_text_value = 4;
   */
  defaultFormalTextValue: string;

  /**
   * @generated from field: string default_informal_text_value = 5;
   */
  defaultInformalTextValue: string;
};

/**
 * Describes the message grpc.api.v1.MessageTranslation.
 * Use `create(MessageTranslationSchema)` to create a new message.
 */
export const MessageTranslationSchema: GenMessage<MessageTranslation> = /*@__PURE__*/
  messageDesc(file_message_preferences, 1);

